import { __extends, __assign } from 'tslib';
import React__default from 'react';
import PaymentForm$1 from './PaymentFormUnconnected.compoment.js';
import { defaultProps } from './PaymentForm.types.js';

var PaymentForm = /** @class */ (function (_super) {
    __extends(PaymentForm, _super);
    function PaymentForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: true,
            isSubmitting: false,
            paymentToken: '',
            postalCode: '',
            isCCExpDirty: false,
            isCCNumberDirty: false,
            isCVVDirty: false,
            isPostalCodeDirty: false,
            ccExpError: '',
            ccNumberError: '',
            cvvError: '',
            postalCodeError: '',
            bin: '',
            hash: '',
            ccExp: '',
            ccNumber: '',
            error: null,
        };
        // bind all the things
        _this.isValid = _this.isValid.bind(_this);
        _this.loadedCollectJS = _this.loadedCollectJS.bind(_this);
        _this.invalidCCNumber = _this.invalidCCNumber.bind(_this);
        _this.invalidCVVNumber = _this.invalidCVVNumber.bind(_this);
        _this.invalidExpirationDate = _this.invalidExpirationDate.bind(_this);
        _this.invalidPostalCode = _this.invalidPostalCode.bind(_this);
        _this.setPostalCode = _this.setPostalCode.bind(_this);
        _this.submitPaymentForm = _this.submitPaymentForm.bind(_this);
        _this.submittedPaymentInfo = _this.submittedPaymentInfo.bind(_this);
        _this.validCCNumber = _this.validCCNumber.bind(_this);
        _this.validExpirationDate = _this.validExpirationDate.bind(_this);
        _this.validCVVNumber = _this.validCVVNumber.bind(_this);
        _this.validPostalCode = _this.validPostalCode.bind(_this);
        _this.setCCNumber = _this.setCCNumber.bind(_this);
        _this.setExpirationDate = _this.setExpirationDate.bind(_this);
        _this.setCardBin = _this.setCardBin.bind(_this);
        _this.setCardHash = _this.setCardHash.bind(_this);
        _this.selectIsPristine = _this.selectIsPristine.bind(_this);
        return _this;
    }
    PaymentForm.prototype.componentDidMount = function () {
        if (this.props.v2) {
            console.warn('DEPRECATED WARNING: The `v2` prop is deprecated and support for it will be removed soon.');
        }
    };
    PaymentForm.prototype.isValid = function () {
        var _a = this.state, isCCNumberDirty = _a.isCCNumberDirty, ccNumberError = _a.ccNumberError, isCCExpDirty = _a.isCCExpDirty, ccExpError = _a.ccExpError, isCVVDirty = _a.isCVVDirty, cvvError = _a.cvvError, isPostalCodeDirty = _a.isPostalCodeDirty, postalCodeError = _a.postalCodeError;
        var isPostalCodeValid = !this.props.isPostalCodeInputVisible ||
            (isPostalCodeDirty && postalCodeError === '');
        return (isCCNumberDirty &&
            ccNumberError === '' &&
            isCCExpDirty &&
            ccExpError === '' &&
            isCVVDirty &&
            cvvError === '' &&
            isPostalCodeValid);
    };
    PaymentForm.prototype.loadedCollectJS = function () {
        this.setState({
            isLoading: false,
        });
    };
    PaymentForm.prototype.invalidCCNumber = function (message) {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            ccNumberError: message,
            isCVVDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.invalidCVVNumber = function (message) {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            cvvError: message,
            isCVVDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.invalidExpirationDate = function (message) {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            ccExpError: message,
            isCCExpDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.invalidPostalCode = function (message) {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            postalCodeError: message,
            isPostalCodeDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.setPostalCode = function (postalCode) {
        var onChangePostalCode = this.props.onChangePostalCode;
        if (onChangePostalCode) {
            onChangePostalCode(postalCode);
        }
        this.setState({
            postalCode: postalCode,
        });
    };
    PaymentForm.prototype.submitPaymentForm = function () {
        var isSubmitting = this.props.isSubmitting;
        // expose the state
        isSubmitting(true);
        this.setState({
            isSubmitting: true,
        }, function () {
            if (window.CollectJS) {
                window.CollectJS.startPaymentRequest();
            }
            else {
                console.warn('[PaymentForm] Could not find collect.js');
            }
        });
    };
    PaymentForm.prototype.submittedPaymentInfo = function (token) {
        var _a = this.props, isSubmitting = _a.isSubmitting, paymentToken = _a.paymentToken;
        // expose the state
        isSubmitting(false);
        paymentToken(token);
        this.setState({
            isSubmitting: false,
            paymentToken: token,
            // isCCNumberDirty: true,
            // isCVVDirty: true,
            // isCCExpDirty: true,
            // isPostalCodeDirty: true,
        });
    };
    PaymentForm.prototype.validCCNumber = function () {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            ccNumberError: '',
            isCCNumberDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.validExpirationDate = function () {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            ccExpError: '',
            isCCExpDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.validCVVNumber = function () {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            cvvError: '',
            isCVVDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.validPostalCode = function () {
        var _this = this;
        var isValid = this.props.isValid;
        this.setState({
            postalCodeError: '',
            isPostalCodeDirty: true,
        }, function () {
            isValid(_this.isValid());
        });
    };
    PaymentForm.prototype.setCCNumber = function (ccNumber) {
        this.setState({
            ccNumber: ccNumber,
        });
    };
    PaymentForm.prototype.setExpirationDate = function (date) {
        this.setState({
            ccExp: date,
        });
    };
    PaymentForm.prototype.setCardBin = function (bin) {
        this.setState({
            bin: bin,
        });
    };
    PaymentForm.prototype.setCardHash = function (hash) {
        this.setState({
            hash: hash,
        });
    };
    PaymentForm.prototype.selectIsPristine = function () {
        var _a = this.state, isCCNumberDirty = _a.isCCNumberDirty, ccNumberError = _a.ccNumberError, isCCExpDirty = _a.isCCExpDirty, ccExpError = _a.ccExpError, isCVVDirty = _a.isCVVDirty, cvvError = _a.cvvError;
        return (!isCCNumberDirty &&
            ccNumberError === '' &&
            !isCCExpDirty &&
            ccExpError === '' &&
            !isCVVDirty &&
            cvvError === '');
    };
    PaymentForm.prototype.render = function () {
        var _a = this.state, isLoading = _a.isLoading, postalCode = _a.postalCode, ccNumberError = _a.ccNumberError, ccExpError = _a.ccExpError, cvvError = _a.cvvError, postalCodeError = _a.postalCodeError, ccNumber = _a.ccNumber, ccExp = _a.ccExp, paymentToken = _a.paymentToken;
        var _b = this.props, ccNumberInputStyles = _b.ccNumberInputStyles, ccExpiryInputStyles = _b.ccExpiryInputStyles, cvvInputStyles = _b.cvvInputStyles, postalCodeInputStyles = _b.postalCodeInputStyles, ccNumberLabel = _b.ccNumberLabel, expirationDateLabel = _b.expirationDateLabel, cvvLabel = _b.cvvLabel, postalCodeLabel = _b.postalCodeLabel, variant = _b.variant, borderColor = _b.borderColor, v2 = _b.v2, isPostalCodeInputVisible = _b.isPostalCodeInputVisible;
        var isPristine = this.selectIsPristine();
        var hasPaymentToken = paymentToken !== '';
        return (React__default.createElement(PaymentForm$1, { isLoading: isLoading, postalCode: postalCode, ccNumberError: ccNumberError, ccExpError: ccExpError, cvvError: cvvError, postalCodeError: postalCodeError, ccNumber: ccNumber, expirationDate: ccExp, isPristine: isPristine, hasPaymentToken: hasPaymentToken, loadedCollectJS: this.loadedCollectJS, invalidCCNumber: this.invalidCCNumber, invalidCVVNumber: this.invalidCVVNumber, invalidExpirationDate: this.invalidExpirationDate, invalidPostalCode: this.invalidPostalCode, setPostalCode: this.setPostalCode, submitPaymentForm: this.submitPaymentForm, submittedPaymentInfo: this.submittedPaymentInfo, validCCNumber: this.validCCNumber, validCVVNumber: this.validCVVNumber, validExpirationDate: this.validExpirationDate, validPostalCode: this.validPostalCode, setCCNumber: this.setCCNumber, setExpirationDate: this.setExpirationDate, setCardBin: this.setCardBin, setCardHash: this.setCardHash, ccNumberInputStyles: ccNumberInputStyles, ccExpiryInputStyles: ccExpiryInputStyles, cvvInputStyles: cvvInputStyles, postalCodeInputStyles: postalCodeInputStyles, ccNumberLabel: ccNumberLabel, expirationDateLabel: expirationDateLabel, postalCodeLabel: postalCodeLabel, cvvLabel: cvvLabel, variant: variant, borderColor: borderColor, v2: v2, isPostalCodeInputVisible: isPostalCodeInputVisible }));
    };
    PaymentForm.displayName = 'PaymentForm';
    PaymentForm.defaultProps = __assign({}, defaultProps);
    return PaymentForm;
}(React__default.Component));

export default PaymentForm;
